export default __webpack_public_path__ + "static/media/discoverFilled.e7a6786b.svg";